import React from "react";

function EmployeeCreate() {
  return (
    <div>
      <p>Employee Create</p>
    </div>
  );
}

export default EmployeeCreate;
